type Props = {
  width?: string;
};
const AICreateIcon = (props: Props) => {
  const width = props.width || "500px";
  return (
    <svg
      height="auto"
      width={width}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1524_4513)">
        <rect
          x="37.5"
          y="93.125"
          width="325"
          height="200"
          rx="18.75"
          fill="white"
        />
      </g>
      <rect
        x="56.25"
        y="68.125"
        width="287.5"
        height="206.25"
        rx="12.5"
        fill="url(#paint0_linear_1524_4513)"
      />
      <path
        d="M200 86.875L200 177.5"
        stroke="url(#paint1_linear_1524_4513)"
        strokeWidth="6.25"
        strokeLinecap="round"
      />
      <g clipPath="url(#clip0_1524_4513)">
        <path
          d="M279.837 121.286C270.503 119.355 263.207 112.154 261.251 102.941C261.01 101.81 260 101 258.829 101C257.657 101 256.647 101.81 256.407 102.941C254.45 112.154 247.154 119.355 237.82 121.286C236.674 121.523 235.854 122.52 235.854 123.676C235.854 124.832 236.674 125.83 237.82 126.067C247.154 127.998 254.45 135.199 256.406 144.411C256.646 145.543 257.657 146.353 258.828 146.353C259.999 146.353 261.01 145.543 261.25 144.411C263.207 135.199 270.502 127.998 279.836 126.067C280.982 125.83 281.803 124.833 281.803 123.677C281.803 122.521 280.982 121.523 279.837 121.286Z"
          fill="url(#paint2_linear_1524_4513)"
        />
        <path
          d="M275.747 161.634C271.349 160.725 267.912 157.332 266.99 152.991C266.75 151.86 265.739 151.05 264.568 151.05C263.397 151.05 262.386 151.86 262.146 152.991C261.224 157.332 257.787 160.724 253.389 161.634C252.243 161.871 251.422 162.869 251.422 164.025C251.422 165.18 252.243 166.178 253.389 166.415C257.786 167.325 261.224 170.718 262.146 175.059C262.386 176.19 263.397 177 264.568 177C265.739 177 266.749 176.19 266.99 175.059C267.912 170.718 271.349 167.325 275.747 166.415C276.893 166.178 277.714 165.181 277.714 164.025C277.714 162.869 276.893 161.872 275.747 161.634Z"
          fill="url(#paint3_linear_1524_4513)"
        />
        <path
          d="M309.179 139.02C303.235 137.79 298.589 133.204 297.343 127.337C297.102 126.206 296.092 125.396 294.921 125.396C293.75 125.396 292.739 126.206 292.499 127.337C291.253 133.204 286.607 137.79 280.662 139.02C279.516 139.257 278.695 140.254 278.695 141.41C278.695 142.566 279.516 143.563 280.662 143.801C286.606 145.03 291.252 149.616 292.498 155.483C292.739 156.614 293.749 157.425 294.92 157.425C296.091 157.425 297.102 156.615 297.342 155.483C298.589 149.616 303.235 145.03 309.179 143.801C310.325 143.564 311.146 142.566 311.146 141.41C311.146 140.255 310.325 139.257 309.179 139.02Z"
          fill="url(#paint4_linear_1524_4513)"
        />
      </g>
      <rect
        x="84.5"
        y="230"
        width="232"
        height="80"
        rx="20"
        fill="url(#paint5_linear_1524_4513)"
      />
      <path
        d="M119.964 280.308C118.489 280.308 117.117 280.056 115.848 279.552C114.597 279.029 113.496 278.301 112.544 277.368C111.61 276.435 110.882 275.352 110.36 274.12C109.837 272.869 109.576 271.525 109.576 270.088C109.576 268.651 109.837 267.316 110.36 266.084C110.882 264.833 111.61 263.751 112.544 262.836C113.477 261.921 114.569 261.212 115.82 260.708C117.089 260.185 118.461 259.924 119.936 259.924C121.504 259.924 122.894 260.176 124.108 260.68C125.34 261.184 126.413 261.875 127.328 262.752L124.388 265.72C123.865 265.16 123.23 264.721 122.484 264.404C121.756 264.087 120.906 263.928 119.936 263.928C119.077 263.928 118.284 264.077 117.556 264.376C116.846 264.656 116.23 265.067 115.708 265.608C115.204 266.149 114.802 266.803 114.504 267.568C114.224 268.333 114.084 269.173 114.084 270.088C114.084 271.021 114.224 271.871 114.504 272.636C114.802 273.401 115.204 274.055 115.708 274.596C116.23 275.137 116.846 275.557 117.556 275.856C118.284 276.155 119.077 276.304 119.936 276.304C120.944 276.304 121.821 276.145 122.568 275.828C123.314 275.511 123.958 275.072 124.5 274.512L127.468 277.48C126.516 278.357 125.424 279.048 124.192 279.552C122.978 280.056 121.569 280.308 119.964 280.308ZM129.496 280V266.392H133.78V280H129.496ZM133.78 272.524L131.988 271.124C132.343 269.537 132.94 268.305 133.78 267.428C134.62 266.551 135.787 266.112 137.28 266.112C137.934 266.112 138.503 266.215 138.988 266.42C139.492 266.607 139.931 266.905 140.304 267.316L137.756 270.536C137.57 270.331 137.336 270.172 137.056 270.06C136.776 269.948 136.459 269.892 136.104 269.892C135.395 269.892 134.826 270.116 134.396 270.564C133.986 270.993 133.78 271.647 133.78 272.524ZM147.783 280.308C146.308 280.308 144.992 280.009 143.835 279.412C142.696 278.796 141.8 277.947 141.147 276.864C140.493 275.781 140.167 274.559 140.167 273.196C140.167 271.833 140.484 270.62 141.119 269.556C141.772 268.473 142.649 267.624 143.751 267.008C144.852 266.392 146.093 266.084 147.475 266.084C148.819 266.084 150.004 266.373 151.031 266.952C152.057 267.531 152.86 268.333 153.439 269.36C154.036 270.387 154.335 271.563 154.335 272.888C154.335 273.131 154.316 273.392 154.279 273.672C154.26 273.933 154.213 274.241 154.139 274.596L142.407 274.624V271.684L152.319 271.656L150.471 272.888C150.452 272.104 150.331 271.46 150.107 270.956C149.883 270.433 149.547 270.041 149.099 269.78C148.669 269.5 148.137 269.36 147.503 269.36C146.831 269.36 146.243 269.519 145.739 269.836C145.253 270.135 144.871 270.564 144.591 271.124C144.329 271.684 144.199 272.365 144.199 273.168C144.199 273.971 144.339 274.661 144.619 275.24C144.917 275.8 145.328 276.239 145.851 276.556C146.392 276.855 147.027 277.004 147.755 277.004C148.427 277.004 149.033 276.892 149.575 276.668C150.116 276.425 150.592 276.071 151.003 275.604L153.355 277.956C152.683 278.74 151.871 279.328 150.919 279.72C149.967 280.112 148.921 280.308 147.783 280.308ZM162.087 280.28C160.836 280.28 159.716 279.972 158.727 279.356C157.756 278.74 156.981 277.9 156.403 276.836C155.843 275.772 155.563 274.559 155.563 273.196C155.563 271.833 155.843 270.62 156.403 269.556C156.981 268.492 157.756 267.652 158.727 267.036C159.716 266.42 160.836 266.112 162.087 266.112C163.001 266.112 163.823 266.289 164.551 266.644C165.297 266.999 165.904 267.493 166.371 268.128C166.837 268.744 167.099 269.453 167.155 270.256V276.136C167.099 276.939 166.837 277.657 166.371 278.292C165.923 278.908 165.325 279.393 164.579 279.748C163.832 280.103 163.001 280.28 162.087 280.28ZM162.955 276.416C163.869 276.416 164.607 276.117 165.167 275.52C165.727 274.904 166.007 274.129 166.007 273.196C166.007 272.561 165.876 272.001 165.615 271.516C165.372 271.031 165.017 270.657 164.551 270.396C164.103 270.116 163.58 269.976 162.983 269.976C162.385 269.976 161.853 270.116 161.387 270.396C160.939 270.657 160.575 271.031 160.295 271.516C160.033 272.001 159.903 272.561 159.903 273.196C159.903 273.812 160.033 274.363 160.295 274.848C160.556 275.333 160.92 275.716 161.387 275.996C161.853 276.276 162.376 276.416 162.955 276.416ZM165.839 280V276.332L166.483 273.028L165.839 269.724V266.392H170.039V280H165.839ZM174.987 280V260.764H179.271V280H174.987ZM171.907 270.032V266.392H182.351V270.032H171.907ZM190.685 280.308C189.21 280.308 187.894 280.009 186.737 279.412C185.598 278.796 184.702 277.947 184.049 276.864C183.396 275.781 183.069 274.559 183.069 273.196C183.069 271.833 183.386 270.62 184.021 269.556C184.674 268.473 185.552 267.624 186.653 267.008C187.754 266.392 188.996 266.084 190.377 266.084C191.721 266.084 192.906 266.373 193.933 266.952C194.96 267.531 195.762 268.333 196.341 269.36C196.938 270.387 197.237 271.563 197.237 272.888C197.237 273.131 197.218 273.392 197.181 273.672C197.162 273.933 197.116 274.241 197.041 274.596L185.309 274.624V271.684L195.221 271.656L193.373 272.888C193.354 272.104 193.233 271.46 193.009 270.956C192.785 270.433 192.449 270.041 192.001 269.78C191.572 269.5 191.04 269.36 190.405 269.36C189.733 269.36 189.145 269.519 188.641 269.836C188.156 270.135 187.773 270.564 187.493 271.124C187.232 271.684 187.101 272.365 187.101 273.168C187.101 273.971 187.241 274.661 187.521 275.24C187.82 275.8 188.23 276.239 188.753 276.556C189.294 276.855 189.929 277.004 190.657 277.004C191.329 277.004 191.936 276.892 192.477 276.668C193.018 276.425 193.494 276.071 193.905 275.604L196.257 277.956C195.585 278.74 194.773 279.328 193.821 279.72C192.869 280.112 191.824 280.308 190.685 280.308ZM207.969 280L203.265 266.392H207.465L210.377 276.276L209.145 276.304L212.365 266.392H215.837L219.085 276.304L217.825 276.276L220.765 266.392H224.965L220.261 280H216.761L213.597 270.592H214.661L211.441 280H207.969ZM226.403 280V266.392H230.687V280H226.403ZM228.559 264.516C227.887 264.516 227.327 264.292 226.879 263.844C226.449 263.377 226.235 262.817 226.235 262.164C226.235 261.492 226.449 260.932 226.879 260.484C227.327 260.036 227.887 259.812 228.559 259.812C229.231 259.812 229.781 260.036 230.211 260.484C230.64 260.932 230.855 261.492 230.855 262.164C230.855 262.817 230.64 263.377 230.211 263.844C229.781 264.292 229.231 264.516 228.559 264.516ZM235.635 280V260.764H239.919V280H235.635ZM232.555 270.032V266.392H242.999V270.032H232.555ZM253.875 280V272.244C253.875 271.535 253.651 270.965 253.203 270.536C252.774 270.088 252.223 269.864 251.551 269.864C251.084 269.864 250.674 269.967 250.319 270.172C249.964 270.359 249.684 270.639 249.479 271.012C249.274 271.367 249.171 271.777 249.171 272.244L247.519 271.432C247.519 270.368 247.743 269.435 248.191 268.632C248.639 267.829 249.264 267.213 250.067 266.784C250.87 266.336 251.794 266.112 252.839 266.112C253.903 266.112 254.836 266.336 255.639 266.784C256.442 267.213 257.058 267.82 257.487 268.604C257.935 269.369 258.159 270.265 258.159 271.292V280H253.875ZM244.887 280V259.672H249.171V280H244.887ZM264.358 280L272.198 260.232H276.174L283.93 280H279.282L273.346 263.592H274.942L268.922 280H264.358ZM268.81 276.416V272.832H279.59V276.416H268.81ZM286.021 280V260.232H290.417V280H286.021Z"
        fill="#002F85"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.25 327.5C156.25 330.952 153.452 333.75 150 333.75C146.548 333.75 143.75 330.952 143.75 327.5C143.75 324.048 146.548 321.25 150 321.25C153.452 321.25 156.25 324.048 156.25 327.5ZM206.25 343.125C206.25 346.577 203.452 349.375 200 349.375C196.548 349.375 193.75 346.577 193.75 343.125C193.75 339.673 196.548 336.875 200 336.875C203.452 336.875 206.25 339.673 206.25 343.125ZM250 333.75C253.452 333.75 256.25 330.952 256.25 327.5C256.25 324.048 253.452 321.25 250 321.25C246.548 321.25 243.75 324.048 243.75 327.5C243.75 330.952 246.548 333.75 250 333.75Z"
        fill="url(#paint6_linear_1524_4513)"
      />
      <path
        d="M88.2692 96.25C85.1247 96.25 82.5755 98.7992 82.5755 101.944V113.331C82.5755 116.476 85.1247 119.025 88.2692 119.025H99.6566C102.801 119.025 105.35 116.476 105.35 113.331V101.944C105.35 98.7992 102.801 96.25 99.6566 96.25H88.2692Z"
        fill="url(#paint7_linear_1524_4513)"
      />
      <path
        d="M159.822 97.6735C160.917 95.7756 163.657 95.7756 164.753 97.6735L174.614 114.755C175.71 116.652 174.34 119.025 172.149 119.025H152.425C150.234 119.025 148.864 116.652 149.96 114.755L159.822 97.6735Z"
        fill="url(#paint8_linear_1524_4513)"
      />
      <path
        d="M91.4974 134.961C92.5932 133.063 95.3325 133.063 96.4283 134.961L106.29 152.042C107.386 153.94 106.016 156.312 103.825 156.312H84.1011C81.9096 156.312 80.5399 153.94 81.6357 152.042L91.4974 134.961Z"
        fill="url(#paint9_linear_1524_4513)"
      />
      <path
        d="M116.738 139.231C116.738 136.086 119.287 133.537 122.431 133.537H133.819C136.963 133.537 139.512 136.086 139.512 139.231V150.618C139.512 153.763 136.963 156.312 133.819 156.312H122.431C119.287 156.312 116.738 153.763 116.738 150.618V139.231Z"
        fill="url(#paint10_linear_1524_4513)"
      />
      <path
        d="M128.125 119.025C134.414 119.025 139.512 113.926 139.512 107.637C139.512 101.348 134.414 96.25 128.125 96.25C121.836 96.25 116.738 101.348 116.738 107.637C116.738 113.926 121.836 119.025 128.125 119.025Z"
        fill="url(#paint11_linear_1524_4513)"
      />
      <path
        d="M139.512 182.637C139.512 188.926 134.414 194.025 128.125 194.025C121.836 194.025 116.738 188.926 116.738 182.637C116.738 176.348 121.836 171.25 128.125 171.25C134.414 171.25 139.512 176.348 139.512 182.637Z"
        fill="url(#paint12_linear_1524_4513)"
      />
      <path
        d="M162.287 156.312C168.576 156.312 173.675 151.214 173.675 144.925C173.675 138.635 168.576 133.537 162.287 133.537C155.998 133.537 150.9 138.635 150.9 144.925C150.9 151.214 155.998 156.312 162.287 156.312Z"
        fill="url(#paint13_linear_1524_4513)"
      />
      <defs>
        <filter
          id="filter0_d_1524_4513"
          x="37.5"
          y="93.125"
          width="331"
          height="206"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="6" dy="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.186235 0 0 0 0 0.521891 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1524_4513"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1524_4513"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1524_4513"
          x1="200"
          y1="57.1875"
          x2="200"
          y2="274.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="0.619792" stopColor="#8FC2FF" />
          <stop offset="1" stopColor="#5CA6FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1524_4513"
          x1="196.875"
          y1="83.75"
          x2="196.875"
          y2="180.625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F7FF" />
          <stop offset="1" stopColor="#A4CDFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1524_4513"
          x1="259"
          y1="115.5"
          x2="254.95"
          y2="148.463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="1" stopColor="#AED3FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1524_4513"
          x1="272.894"
          y1="151.05"
          x2="268.576"
          y2="179.505"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="1" stopColor="#AED3FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1524_4513"
          x1="306"
          y1="129.5"
          x2="298.231"
          y2="162.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="1" stopColor="#AED3FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1524_4513"
          x1="200.5"
          y1="230"
          x2="200.5"
          y2="312.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFDCFF" />
          <stop offset="0.395833" stopColor="#B3D5FF" />
          <stop offset="1" stopColor="#79B6FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1524_4513"
          x1="200"
          y1="311.875"
          x2="196.886"
          y2="349.115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82BBFF" />
          <stop offset="1" stopColor="#D0E5FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1524_4513"
          x1="157.812"
          y1="96.25"
          x2="169.129"
          y2="166.399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="1" stopColor="#A8D0FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1524_4513"
          x1="157.812"
          y1="96.25"
          x2="169.129"
          y2="166.399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="1" stopColor="#A8D0FF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1524_4513"
          x1="157.812"
          y1="96.25"
          x2="169.129"
          y2="166.399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="1" stopColor="#A8D0FF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1524_4513"
          x1="157.812"
          y1="96.25"
          x2="169.129"
          y2="166.399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="1" stopColor="#A8D0FF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1524_4513"
          x1="157.812"
          y1="96.25"
          x2="169.129"
          y2="166.399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="1" stopColor="#A8D0FF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1524_4513"
          x1="157.812"
          y1="96.25"
          x2="169.129"
          y2="166.399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="1" stopColor="#A8D0FF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1524_4513"
          x1="157.812"
          y1="96.25"
          x2="169.129"
          y2="166.399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F8FF" />
          <stop offset="1" stopColor="#A8D0FF" />
        </linearGradient>
        <clipPath id="clip0_1524_4513">
          <rect
            width="77"
            height="76"
            fill="white"
            transform="translate(235 101)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AICreateIcon;
